import React from 'react';
import './ProgressCube.css';
import {FirstStep, SecondStep, ThirdStep, FourthStep} from './cubes';
import i18n from 'i18next';

const cubesBySteps = {
	1: FirstStep,
	2: SecondStep,
	3: ThirdStep,
	4: FourthStep,
};
function convertCentToAmount(cents) {
	return Math.trunc(cents / 100);
}

function getPayoutAmount(total, currency, step, extra, totalCoupon) {
	const lang = i18n.language.split("-")[0] ? i18n.language.split("-")[0] : "en";
    const formatter = new Intl.NumberFormat(lang, {
        style: 'currency',
        currency: currency.toUpperCase(),
        minimumFractionDigits: 0,
    });

    //console.log(i18n.language + " " + currency);
    //console.log(formatter.format(convertCentToAmount(total * step + extra)));
	//(total + totalCoupon) * period - totalCoupon + extraPayout2
	if(step === 1){
        return formatter.format(convertCentToAmount(total * step + extra));
	}else{
        return formatter.format(convertCentToAmount((total + totalCoupon) * step - totalCoupon + extra));
	}
}

export default function ProgressCube({t,
	currentStep = 1,
	daysremaining = 30,
	initialOrder,
}) {
	const {total, currency, workouts_per_order} = initialOrder;
    const totalCoupon = initialOrder.total_coupon ? initialOrder.total_coupon : 0;

	const Cube = cubesBySteps[currentStep <= 4 ? currentStep : 4];
	const stepsInfo = [1, 2, 3, 4].reduce((prev, curr) => {
		const reward = getPayoutAmount(
			total,
            currency,
			curr,
			initialOrder[`extra_payout_${curr}`],
            totalCoupon
		);
		const duration = `${workouts_per_order * curr} ${t('common:month')}`;
		Object.assign(prev, {
			[`step${curr}reward`]: reward,
			[`step${curr}duration`]: duration,
		});
		return prev;
	}, {});
	const allProps = {
		daysremaining,
		...stepsInfo,
	};
	return (
		<div className='progressCube' style={{fontFamily: 'Graphik'}}>
			<Cube {...allProps} />
			<p className='progressDesc'>{t('common:yourPayout')}</p>
		</div>
	);
}



// WEBPACK FOOTER //
// ./src/components/ProgressCube.js